/* Progressive carousel controls only. Native Shopify product forms remain unchanged. */
if (!customElements.get('be-curated-home')) {
  customElements.define('be-curated-home', class extends HTMLElement {
    connectedCallback() {
      this._abort?.abort();
      this._resize?.disconnect();
      this._abort = new AbortController();
      const signal = this._abort.signal;
      const refreshers = [];
      this.querySelectorAll('[data-be-rail]').forEach(section => {
        const track = section.querySelector('[data-be-track]');
        const controls = section.querySelector('[data-be-controls]');
        if (!track || !controls) return;
        const previous = controls.querySelector('[data-be-prev]');
        const next = controls.querySelector('[data-be-next]');
        if (!previous || !next) return;
        const refresh = () => {
          const remaining = track.scrollWidth - track.clientWidth;
          controls.hidden = remaining < 4;
          previous.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= remaining - 2;
        };
        const move = direction => track.scrollBy({left: direction * Math.max(160, track.clientWidth * .8), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        previous.addEventListener('click', () => move(-1), {signal});
        next.addEventListener('click', () => move(1), {signal});
        track.addEventListener('scroll', refresh, {passive:true, signal});
        refreshers.push(refresh);
        refresh();
      });
      if ('ResizeObserver' in window) {
        this._resize = new ResizeObserver(() => refreshers.forEach(refresh => refresh()));
        this._resize.observe(this);
      }
    }
    disconnectedCallback() {
      this._abort?.abort();
      this._resize?.disconnect();
    }
  });
}
